import { IssueRuntimeEvidenceTab } from "../IssueRuntimeEvidenceTab"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const RuntimeEvidenceTabTriageDrawer = (props: TabComponentProps) => {
  return <IssueRuntimeEvidenceTab {...props} />
}
